import { useEffect } from 'react';
export function useOutsideAlerter(refs, close) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (!(refs === null || refs === void 0 ? void 0 : refs.current)) {
                return;
            }
            const clickWithinActiveElements = refs.current
                .filter(Boolean)
                .some((el) => el === null || el === void 0 ? void 0 : el.contains(event.target));
            if (clickWithinActiveElements) {
                return;
            }
            // trigger close if click is outside desired elements
            close();
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [refs, close]);
}
//# sourceMappingURL=useOutsideAlerter.js.map